var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import sendAPIRequest from '../../../helpers/api/plugNmeetAPI';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateIsActiveRaisehand } from '../../../store/slices/bottomIconsActivitySlice';
import { SystemMsgType } from '../../../store/slices/interfaces/dataMessages';
import { CommonResponse, DataMessageReq, } from '../../../helpers/proto/plugnmeet_common_api_pb';
import { DataMsgBodyType } from '../../../helpers/proto/plugnmeet_datamessage_pb';
const isActiveRaisehandSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveRaisehand);
$RefreshReg$(_react_refresh_temp_1, "isActiveRaisehandSelector$createSelector");
const RaiseHandIcon = ({ currentRoom }) => {
    _react_refresh_temp_3();
    const showTooltip = store.getState().session.userDeviceType === 'desktop';
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const isActiveRaisehand = useAppSelector(isActiveRaisehandSelector);
    const [iconCSS, setIconCSS] = useState('primaryColor');
    useEffect(() => {
        if (isActiveRaisehand) {
            setIconCSS('secondaryColor');
        }
        else {
            setIconCSS('primaryColor dark:text-darkText');
        }
    }, [isActiveRaisehand]);
    const toggleRaiseHand = async () => {
        if (!isActiveRaisehand) {
            const body = new DataMessageReq({
                roomSid: currentRoom.sid,
                roomId: currentRoom.name,
                msgBodyType: DataMsgBodyType.RAISE_HAND,
                msg: t('footer.notice.has-raised-hand', {
                    user: currentRoom.localParticipant.name,
                }).toString(),
            });
            const r = await sendAPIRequest('dataMessage', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
            const res = CommonResponse.fromBinary(new Uint8Array(r));
            if (res.status) {
                dispatch(updateIsActiveRaisehand(true));
                toast(t('footer.notice.you-raised-hand'), {
                    type: 'info',
                });
            }
            else {
                toast(res.msg, {
                    type: 'error',
                });
            }
        }
        else {
            const body = new DataMessageReq({
                roomSid: currentRoom.sid,
                roomId: currentRoom.name,
                msgBodyType: DataMsgBodyType.LOWER_HAND,
                msg: SystemMsgType.LOWER_HAND,
            });
            const r = await sendAPIRequest('dataMessage', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
            const res = CommonResponse.fromBinary(new Uint8Array(r));
            if (res.status) {
                dispatch(updateIsActiveRaisehand(false));
            }
            else {
                toast(res.msg, {
                    type: 'error',
                });
            }
        }
    };
    const render = () => {
        var _a;
        const room_features = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features;
        if (typeof (room_features === null || room_features === void 0 ? void 0 : room_features.allow_raise_hand) !== 'undefined' &&
            (room_features === null || room_features === void 0 ? void 0 : room_features.allow_raise_hand) === false) {
            return null;
        }
        return (_jsxs("div", { className: `hands footer-icon h-[35px] lg:h-[40px] w-[35px] lg:w-[40px] overflow-hidden rounded-full bg-[#F2F2F2] dark:bg-darkSecondary2 hover:bg-[#ECF4FF] ltr:mr-3 lg:ltr:mr-6 rtl:ml-3 lg:rtl:ml-6 flex items-center justify-center cursor-pointer ${showTooltip ? 'has-tooltip' : ''}`, onClick: () => toggleRaiseHand(), children: [_jsx("span", { className: "tooltip !bottom-[62px]", children: isActiveRaisehand
                        ? t('footer.icons.lower-hand')
                        : t('footer.icons.raise-hand') }), _jsx("i", { className: `pnm-raise-hand ${iconCSS} text-[14px] lg:text-[16px]` })] }));
    };
    return render();
};
_react_refresh_temp_2 = RaiseHandIcon;
$RefreshReg$(_react_refresh_temp_2, "RaiseHandIcon");
_react_refresh_temp_3(RaiseHandIcon, "Icmx3Zpzx9or6108TsxoC4uj8Hw=", false, () => [useTranslation, useAppDispatch, useAppSelector]);
export default RaiseHandIcon;
